"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _merchantElectricity = require("@/api/merchantElectricity");
var _constants = require("../constants");
var _utils = require("../utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BillDetailDrawer',
  data: function data() {
    return {
      visible: false,
      loading: false,
      acting: false,
      exportLoading: false,
      billId: null,
      bill: null,
      payerName: '',
      payeeName: '',
      payerAid: null,
      payeeAid: null,
      merchantName: '',
      storeName: '',
      devices: [],
      payer: null
    };
  },
  computed: {
    statusMeta: function statusMeta() {
      if (!this.bill) return _constants.BILL_STATUS[0];
      return _constants.BILL_STATUS[this.bill.status] || {
        label: this.bill.status_text,
        type: 'info'
      };
    },
    payerDisplay: function payerDisplay() {
      var bill = this.bill || {};
      var name = this.payerName || bill.payer_name || this.payer && this.payer.name || '';
      var aid = this.payerAid != null ? this.payerAid : bill.agent_aid != null ? bill.agent_aid : this.payer && this.payer.aid;
      return (0, _utils.formatAccount)(aid, name);
    },
    payeeDisplay: function payeeDisplay() {
      var bill = this.bill || {};
      var name = this.payeeName || bill.payee_name || this.merchantName || bill.merchant_name || '';
      var aid = this.payeeAid != null ? this.payeeAid : bill.merchant_aid != null ? bill.merchant_aid : null;
      return (0, _utils.formatAccount)(aid, name);
    }
  },
  methods: {
    formatMoney: _utils.formatMoney,
    formatKwh: _utils.formatKwh,
    open: function open(billId) {
      this.billId = billId;
      this.visible = true;
      this.loadDetail();
    },
    onClosed: function onClosed() {
      this.bill = null;
      this.payerName = '';
      this.payeeName = '';
      this.payerAid = null;
      this.payeeAid = null;
      this.merchantName = '';
      this.devices = [];
      this.payer = null;
    },
    loadDetail: function loadDetail() {
      var _this = this;
      this.loading = true;
      (0, _merchantElectricity.getBillDetail)(this.billId).then(function (res) {
        _this.bill = res.bill || {};
        _this.merchantName = res.merchant_name || _this.bill.merchant_name || '';
        _this.payerName = res.payer_name || _this.bill.payer_name || res.payer && res.payer.name || '';
        _this.payeeName = res.payee_name || _this.bill.payee_name || _this.merchantName || '';
        _this.payerAid = _this.bill.agent_aid != null ? _this.bill.agent_aid : res.payer && res.payer.aid;
        _this.payeeAid = _this.bill.merchant_aid != null ? _this.bill.merchant_aid : null;
        _this.storeName = res.store_name || _this.bill.store_name || '';
        _this.devices = res.devices || [];
        _this.payer = res.payer || null;
      }).catch(function (err) {
        _this.$message.error(err && err.msg || '加载详情失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleConfirm: function handleConfirm() {
      var _this2 = this;
      this.$confirm('确认该月度账单数据无误？', '确认账单', {
        type: 'warning'
      }).then(function () {
        _this2.acting = true;
        return (0, _merchantElectricity.confirmBill)(_this2.billId);
      }).then(function () {
        _this2.$message.success('已确认');
        _this2.$emit('changed');
        _this2.loadDetail();
      }).catch(function () {}).finally(function () {
        _this2.acting = false;
      });
    },
    handleSettle: function handleSettle() {
      var _this3 = this;
      var amount = (0, _utils.formatMoney)(this.bill && this.bill.total_amount);
      var tip = "\u5C06\u4ECE\u3010".concat(this.payerDisplay, "\u3011\u94B1\u5305\u5212\u81F3\u3010").concat(this.payeeDisplay, "\u3011\u94B1\u5305\uFF0C\u91D1\u989D ").concat(amount, "\u3002\u4F59\u989D\u4E0D\u8DB3\u5C06\u5931\u8D25\uFF0C\u662F\u5426\u7EE7\u7EED\uFF1F");
      this.$confirm(tip, '打款结算', {
        type: 'warning'
      }).then(function () {
        _this3.acting = true;
        return (0, _merchantElectricity.settleBill)(_this3.billId);
      }).then(function () {
        _this3.$message.success('打款成功');
        _this3.$emit('changed');
        _this3.loadDetail();
      }).catch(function (err) {
        if (err && err.msg) _this3.$message.error(err.msg);
      }).finally(function () {
        _this3.acting = false;
      });
    },
    handleExportBill: function handleExportBill() {
      var _this4 = this;
      if (!this.billId) return;
      this.exportLoading = true;
      (0, _merchantElectricity.exportMonthlyBill)({
        bill_id: this.billId,
        bill_month: this.bill && this.bill.bill_month
      }).catch(function () {}).finally(function () {
        _this4.exportLoading = false;
      });
    }
  }
};